import FileRecord from "models/view-models/file-record";
import React from "react";
import FileUploadDestination from "utilities/enumerations/file-upload-destination";
import useFile from "utilities/hooks/domain/files/use-file";
import ImagePreviewField from "molecules/form-fields/image-preview-field";
const CSS_BASE_CLASS = "notebook-page-cover-image-uploader";
interface NotebookPageCoverUploaderProps {
    coverImage: FileRecord | undefined;
    coverImageId?: number;
    setCoverImage: React.Dispatch<React.SetStateAction<FileRecord | undefined>>;
    currentUserId: number | undefined;
    onDeleteFile: (fileToDelete: FileRecord) => Promise<void>;
}
const NotebookPageCoverImageUploader = (
    props: NotebookPageCoverUploaderProps
) => {
    const { coverImage, setCoverImage, coverImageId, onDeleteFile } = props;

    const handleSaveImageFile = async (imageFile: FileRecord | undefined) => {
        setCoverImage(imageFile);
    };

    const { file } = useFile(coverImageId);
    const fileToDisplay = coverImage ?? file;

    const handleDeleteImageFile = async () => {
        if (!fileToDisplay) {
            return;
        }
        await onDeleteFile(fileToDisplay!);
        setCoverImage(undefined);
    };

    return (
        <div className={`${CSS_BASE_CLASS}`}>
            <ImagePreviewField
                image={fileToDisplay}
                imageDestination={FileUploadDestination.NotebookImage}
                onAdd={handleSaveImageFile}
                onDelete={handleDeleteImageFile}
            />
        </div>
    );
};

export default NotebookPageCoverImageUploader;
